import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

// common
import useGeneralHook from 'common/hook/useGeneralHook';
import useService from 'common/hook/useService';

// screen
import type { CreateConfirmationCodeBody, CreatedConfirmationCode } from 'modules/confirmation-code/types';

/** Tạo MỘT Mã xác nhận (Figma: 1 mã/lần). */
const useCreateConfirmationCodes = () => {
  const service = useService();
  const { enqueueSnackbar } = useGeneralHook();

  const mutation = useMutation({
    mutationFn: async (body: CreateConfirmationCodeBody): Promise<CreatedConfirmationCode | null> => {
      if (!service) return null;
      try {
        const res = await service.ConfirmationCodeController_create(body);
        enqueueSnackbar({ message: 'Tạo mã xác nhận thành công.', variant: 'success' });
        return res?.data ?? null;
      } catch (error) {
        const data = (error as AxiosError<{ code?: string; Code?: string }>)?.response?.data;
        enqueueSnackbar({
          message: `Tạo mã thất bại${data?.code || data?.Code ? ` (${data?.code || data?.Code})` : ''}.`,
          variant: 'error',
        });
        throw error;
      }
    },
  });

  return { mutateAsync: mutation.mutateAsync, isPending: mutation.isPending };
};

export default useCreateConfirmationCodes;
